﻿var logging = {

	// These are setup to assist with the posting to the controller
	LogEvent: function (eventUrl, data, async) {
		$.ajax({
			type: "POST",
			url: eventUrl,
			data: JSON.stringify(data),
			contentType: "application/json; charset=utf-8",
			success: function (){},
			dataType: "json",
			async: typeof async !== 'undefined' ? async : true
		});
	},

	LinkClick: function (linkInfo) {
		var pageSource = logging.currentPage;

		if (linkInfo) {
			pageSource += " | " + linkInfo;
		}

		logging.LogEvent($("body").data("secureDomain") + "/logging/LinkClick", pageSource);
	},

	HoverHelp: function (hoverInfo) {
		var pageSource = logging.currentPage;

		if (hoverInfo) {
			pageSource += " | " + hoverInfo;
		}

		logging.LogEvent($("body").data("secureDomain") + "/logging/HoverHelp", pageSource);
	},

	PageLoad: function (loadTime) {
		var data = {};
		data.PageLoadTime = loadTime;
		data.PageSource = logging.currentPage;

		logging.LogEvent($("body").data("secureDomain") + '/logging/PageLoad', data);
	},

	Registration: function(emailAddress) {
		var data = {};
		data.PageSource = logging.currentPage;
		data.EmailAddress = emailAddress;
		data.ErrorMessageCount = logging.currentErrorCount;
		data.ValidationErrors = logging.validationErrors;

		logging.LogEvent($("body").data("secureDomain") + '/logging/RegistrationEvent', data, false);
	},

	Payment: function(differentShippingAddress, selectPayPal) {
		var data = {};
		data.PageSource = logging.currentPage;
		data.DifferentShippingAddress = differentShippingAddress;
		data.SelectPayPal = selectPayPal;
		data.ErrorMessageCount = logging.currentErrorCount;
		data.ValidationErrors = logging.validationErrors;

		logging.LogEvent($("body").data("secureDomain") + '/logging/PaymentEvent', data, false);
	},

	Review: function() {
		var data = {};
		data.PageSource = logging.currentPage;
		data.Coupons = logging.couponInformation.coupons;
		data.CouponErrors = logging.couponInformation.couponErrors;

		try {
	        localStorage.removeItem('couponInformation');
		}
	    catch (err) {
	    }
		logging.LogEvent($("body").data("secureDomain") + '/logging/ReviewEvent', data, false);
	},

	AddValidationErrors: function(vErrors) {
		logging.validationErrors = logging.validationErrors.concat(vErrors);
	},

	currentErrorCount: 0,

	validationErrors: [],

	couponInformation : {
		coupons: [],
		couponErrors: 0
	},

	SetCoupons: function () {
	    try {
	        logging.couponInformation = JSON.parse(localStorage.getItem('couponInformation')) || logging.couponInformation;
	        localStorage.removeItem('couponInformation');
	    }
	    catch (err) {
	    }
	},

	StoreCoupons: function (coupons) {
	    try {
	        localStorage.setItem('couponInformation', JSON.stringify(coupons));
	    }
	    catch (err) {
	    }
	}
};

// This sets the current page and logs the pageload time.
$(function () {
	logging.currentPage = typeof s_pageName === "undefined" ? "ancestry us : secure : signup : unknown" : s_pageName;

	if (window.performance && window.performance.timing) {
		var now = new Date().getTime();
		var pageLoadTime = now - window.performance.timing.navigationStart;
		logging.PageLoad(pageLoadTime);
	}
});

